import React from "react";
import { useFormikContext } from "formik";
import BlockItem from "components/FormerEditor/BlockItem";
import get from "lodash/get";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { STATE_KEYS } from "utils/constants/state";
import { reorderManifestLayout } from "utils/manifest";
import { DRAG_BLOCK } from "utils/analytics";
import { usePageBuilderContext } from "utils/context";
import Padder from "components/Padder";
import { listDragProps, listItemDragProps } from "utils/drag";

const BlockList = ({ name }) => {
  const pageContext = usePageBuilderContext();
  const tracking = pageContext ? pageContext.tracking : {};
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const entities = get(values, STATE_KEYS.MANIFEST.ENTITIES, []);
  const layout = get(values, STATE_KEYS.MANIFEST.LAYOUT, []);
  const orderedEntities = layout.reduce((memo, layout) => {
    const entityMatch = entities.find(({ uuid }) => layout.uuid === uuid);
    if (entityMatch) {
      memo.push(entityMatch);
    }
    return memo;
  }, []);

  const blockNodes = orderedEntities.map((entity, entityIx) => {
    const blockItemProps = {
      name,
      ...entity
    };

    const dragProps = {
      key: entity.uuid,
      draggableId: entity.uuid,
      index: entityIx
    };
    if (
      entity.validation &&
      typeof entity.validation.position !== "undefined"
    ) {
      dragProps.isDragDisabled = true;
    }

    return (
      <Draggable {...dragProps}>
        {(provided, snapshot) => (
          <li {...listItemDragProps(provided, { cursor: "auto" })}>
            <BlockItem
              key={entityIx}
              {...blockItemProps}
              draggable
              snapshot={snapshot}
              provided={provided}
            />
          </li>
        )}
      </Draggable>
    );
  });

  return (
    <div className="h-100 w-100 w3 bg-white bh--inset relative overflow-y-scroll-ns">
      <DragDropContext
        onDragEnd={reorderManifestLayout({
          entities,
          layout,
          setFieldTouched,
          setFieldValue,
          tracking: {
            event: DRAG_BLOCK,
            data: {
              ...tracking
            }
          }
        })}
      >
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <ul {...listDragProps({ provided, snapshot })}>
              {blockNodes}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
      <Padder customClasses="dib h5-5 w-100 bg-white bh--inset" />
    </div>
  );
};

export default BlockList;
